export default __webpack_public_path__ + "static/media/patients_doc.2fed8164.png";